import { Box, Stack, Typography } from '@mui/material';
import BusinessImg1 from '../../../../../../app/assets/images/landing/BusinessImg1.jpg';
import BusinessImg2 from '../../../../../../app/assets/images/landing/BusinessImg2.jpg';
import BusinessImg3 from '../../../../../../app/assets/images/landing/BusinessImg3.jpg';
import BusinessImg4 from '../../../../../../app/assets/images/landing/BusinessImg4.jpg';
import BusinessImg5 from '../../../../../../app/assets/images/landing/BusinessImg5.jpg';
import BusinessImg6 from '../../../../../../app/assets/images/landing/BusinessImg6.jpg';
import sectionConstants from '../../constants/SectionConstants';
import { JackInTheBox } from 'react-awesome-reveal';
import '../styles/Section4.scss';

const Section4 = () => {
  const data = [
    {
      image: BusinessImg1,
      content:
        'Implement a comprehensive vehicle tracking and management system to boost operational efficiency and meet regulatory compliance standards effectively'
    },
    {
      image: BusinessImg5,
      content:
        'Optimize route planning, vehicle utilization, and driver productivity to maximize fleet efficiency and performance'
    },
    {
      image: BusinessImg3,
      content:
        'Enhance customer satisfaction by delivering real-time updates on vehicle locations and estimated arrival times'
    },
    {
      image: BusinessImg4,
      content:
        'Foster transparency and accountability in logistics operations through the adoption of advanced tracking technologies, ensuring seamless operations and customer service excellence'
    },
    {
      image: BusinessImg2,
      content:
        'Streamline fleet operations to minimize fuel consumption and maintenance expenses while enhancing overall productivity'
    },
    {
      image: BusinessImg6,
      content:
        'Promote safe driving practices, monitor driver behavior, and mitigate the risk of accidents and incidents proactively'
    }
  ];
  return (
    <Box>
      <Box>
        <Box className='section4-landing-image'>
          <Stack className='section4-typo-content'>
            <Typography component='h1' className='section4-heading'>
              {sectionConstants.BusinessObjective}
            </Typography>
            {data.map((item, index) => (
              <Box>
                <Stack
                  key={index}
                  className={`section4-business-card ${
                    index % 2 === 0 ? 'left' : 'right'
                  } ${index % 2 === 0 ? 'row' : 'row-reverse'}`}
                  alignItems='center'
                  mb={3}
                >
                  <Box component='img' src={item.image} className='image' />
                  <JackInTheBox duration={800}>
                    <Typography paragraph className='section4-content'>
                      {item.content}
                    </Typography>
                  </JackInTheBox>
                </Stack>
              </Box>
            ))}
          </Stack>
        </Box>
      </Box>
    </Box>
  );
};

export default Section4;

